// src/components/About/About.jsx

import * as React from "react";
import { Typography, Grid, Paper, Box } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import image1 from "../../assets/images/bio1.jpg";
import image2 from "../../assets/images/bio2.jpg";
import image3 from "../../assets/images/bio3.jpg";
import HorizontalScroll from "../HorizontalScroll/HorizontalScroll";

const About = () => {
  const carouselItems = [
    { image: image1, caption: "First Image" },
    { image: image2, caption: "Second Image" },
    { image: image3, caption: "Third Image" },
  ];

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      mt={3}
      justifyContent="space-evenly"
      padding={3}
    >
      {/* ─────────────── LEFT: Carousel ─────────────── */}
      <Grid item xs={12} md={4}>
        <Carousel
          autoPlay
          indicators={false}
          navButtonsAlwaysInvisible
          fullHeightHover={false}
          animation="fade"
        >
          {carouselItems.map((item, index) => (
            <Paper
              key={index}
              sx={{
                overflow: "hidden",
                boxShadow: "none",
                borderRadius: 0,
              }}
            >
              <Box
                component="img"
                src={item.image}
                alt={item.caption}
                sx={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Paper>
          ))}
        </Carousel>
      </Grid>

      {/* ─────────────── RIGHT: Text ─────────────── */}
      <Grid item xs={12} md={5} paddingLeft={0}>
        <Typography
          variant="body1"
          sx={{
            textAlign: "justify",
            wordSpacing: 0,
            letterSpacing: 0,
            whiteSpace: "break-spaces",
            lineHeight: 1.6,
            pl: 0,
          }}
        >
          With a fashion career that spans over six years, Jordan-based stylist
          Haifaa Khalid has an extensive folio of work. From Fashion Design,
          where her career began, to working as a Creative Director, Editorial
          Stylist and Personal Celebrity Stylist, Haifaa is continually seeking
          opportunities to grow and expand her repertoire. With formal
          qualifications—a Fashion Styling Diploma from the London College of
          Style and a Master's Degree in Fashion Styling (Advanced Editorial,
          Personal Styling, and Professional Styling) from the Australian Style
          Institute—when working with Haifaa you'll not only get the experience
          of a trained professional stylist, but you'll also see the passion and
          dedication she has to her craft and the impact it has on any project
          she is a part of.
        </Typography>
      </Grid>

      {/* ─────────── BELOW: Horizontal Scroll ─────────── */}
      <Grid item xs={12} md={10} marginTop={3}>
        <HorizontalScroll />
      </Grid>
    </Grid>
  );
};

export default About;
